import type {MilestonePickerMilestone$data} from '@github-ui/item-picker/MilestonePickerMilestone.graphql'
import {noop} from '@github-ui/noop'
import {ActionList, Box} from '@primer/react'

import {LABELS} from '../../constants/labels'
import {TEST_IDS} from '../../constants/test-ids'
import {ProgressIcon} from './ProgressIcon'

function getMilestoneDescription(dueOn: string | null | undefined, progressPercentage: number | null | undefined) {
  let description = ''

  if (dueOn) {
    description += LABELS.milestones.dueOn(dueOn)
  } else {
    description += LABELS.milestones.noDueDate
  }
  if (progressPercentage) {
    description += LABELS.milestones.progressPercentage(progressPercentage)
  }

  return description
}

type MilestoneProps = {
  milestone?: MilestonePickerMilestone$data | null
  anchorProps?: React.HTMLAttributes<HTMLElement>
}

export function Milestone({milestone, anchorProps}: MilestoneProps) {
  return (
    <>
      {milestone ? (
        <ActionList.LinkItem
          href={milestone.url || '#'}
          target="_blank"
          key={milestone.id}
          data-testid={TEST_IDS.milestoneContainer}
          {...anchorProps}
          onClick={noop}
        >
          <ActionList.LeadingVisual>
            <ProgressIcon progress={milestone.progressPercentage / 100} />
          </ActionList.LeadingVisual>
          {milestone.title}
          <ActionList.Description variant="block">
            {getMilestoneDescription(milestone.dueOn, milestone.progressPercentage)}
          </ActionList.Description>
        </ActionList.LinkItem>
      ) : (
        <Box sx={{height: '0px', p: 0, m: 0, border: '0', visibility: 'hidden'}} {...anchorProps} />
      )}
    </>
  )
}

try{ Milestone.displayName ||= 'Milestone' } catch {}